import { alert } from 'actions/flash'
import { buildTranslate } from 'locales'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { replace } from 'react-router-redux'

const t = buildTranslate('components.zendesk')

// Zendesk sends users here after they sign out of the Help Center, and also
// when it refuses a sign-in (?kind=error). Zendesk's own message stays in the
// URL for debugging; the user sees our copy.
const ZendeskLogout = ({ location }: RouteComponentProps) => {
  const dispatch = useDispatch()
  const refused = new URLSearchParams(location.search).get('kind') === 'error'

  useEffect(() => {
    // Navigating clears existing flash alerts, so navigate before alerting.
    dispatch(replace('/'))
    if (refused) {
      dispatch(alert({ key: 'danger', message: t('sign_in_refused') }))
    }
  }, [dispatch, refused])

  return null
}

export default ZendeskLogout
